
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as blank_454CgMiO_45ytpIoOmQYBdvQmj7lloSpwAuDfTog23zS_45UMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/blank.vue?macro=true";
import { default as errorlvrsWUDuucH9sYiDzQttiGw74pg7qzkM7CLzfyw5EdUMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/error.vue?macro=true";
import { default as index0OeBNgGf4LSnPkvLZpORJIzu2l7E9ZvknOXHDp5Jb7YMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/index.vue?macro=true";
import { default as login5TZ7TjQML4AXHn279p94TtbDUV0RvccVQmgVjYsjU9EMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/login.vue?macro=true";
import { default as logoutC9UJ_r3lSccIRH7dPmEYimu61V2WylamwOEFfiNEe_gMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/logout.vue?macro=true";
import { default as indexEZZqrnrRMOMP3vMNU7XHrKGkwHY_B_45zPHH3qcHpg16kMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/index.vue?macro=true";
import { default as index_45LqpcP6Q3O8eqA6AKBhDvaR9PHNtwX9JfqGEntAVcfEMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/admin/index.vue?macro=true";
import { default as leaderboardun0JaHK_c_45_JR3Nvwqja5MYdOhG23hXzz_OlXwjpgzsMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/leaderboard.vue?macro=true";
import { default as brandsZ3E6ppNgPhdIYt7ASJqrEijEXHCB674qLIZD5ZVDDqcMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/brands.vue?macro=true";
import { default as newqglPmX_45o6jJSNTKDqmYyjC_451yayrQDJu6L_45VNZ9PmiIMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/new.vue?macro=true";
import { default as contactIlVU6mtlIIurch47MYFjYYrex5ny_uSSkM_45qAgKr9VsMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/contact.vue?macro=true";
import { default as expertsrRJ91LHBfY88U4pHXwRv3R3SKs3NJ_45dFOQ2bViWfAvMMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/experts.vue?macro=true";
import { default as indexAqJaCtb7_45tHGdVqfgOn5J_gT0u_45FhbHMQ1Zvu40iKAMMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/meetups/index.vue?macro=true";
import { default as indexLIgf_mVZO1riEjXKjCV_45tFVnATzejwerFRUBOZo_45LB4Meta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/profile/index.vue?macro=true";
import { default as creatorsKLg_QwzlNRI_45xSeu93A8Wznoa_45IHsRpXKOKneRv_yt0Meta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/creators.vue?macro=true";
import { default as index7I4ejZCOWgRX4_45ggTzND4temB9Dkijk7ymmP8lHTDTYMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/exercise/index.vue?macro=true";
import { default as index0dBZAy4lPn60lPp5LJgDoipS5m9fiQePANYJWOE2fPIMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/magazine/index.vue?macro=true";
import { default as indexHSg5gbaxroevqRh0_ySpqRm2Kl25wYNifhIg7QKA_DgMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/password/index.vue?macro=true";
import { default as indexBS0VRiD4GP3W9GD1PIlVG0BcjpN62R2AJyShLeSBCDQMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/index.vue?macro=true";
import { default as indexKaS12zKuNW_45_9K6smYFtkUEOo_45QNRfpxukA0v732X6cMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/register/index.vue?macro=true";
import { default as mbgSMJElAs7p_K0JaxJIfR_rqn1qNsHUSdDWQovKY_45Bd0MMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/terms/mbg.vue?macro=true";
import { default as verifyzdvt3SBxAxHHf5xzG7SlBVCJhmgkiN6mhfaENEU9ODMMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/password/verify.vue?macro=true";
import { default as zotrimjcEgQ8TnRMVn_45715lIkmyYya7pDWC2FV07n4NTeYgBIMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/zotrim.vue?macro=true";
import { default as verifyJ2i0o8Zx2eZg3BYY_45fYkZLSbS5stdLKJnJtgM8_CaV4Meta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/register/verify.vue?macro=true";
import { default as affiliates3W09IaoILfcRSjhR1UbIu8XnNzuLnvNqchak1UiL_45JsMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/affiliates.vue?macro=true";
import { default as index_45XqOFcLn5L6AryCO97M_avKTn_zM7vqFVVAdR9st3jcMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/challenges/index.vue?macro=true";
import { default as request7oYlp1CgbK3IU2tZ97UifnV9ooWQ9S0UylmzQQgY0r0Meta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/magazine/request.vue?macro=true";
import { default as indexM_E7Tn1WTLo7gQGjLZUqPgkAu8la7e502mXpUq3BDZoMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/terms/index.vue?macro=true";
import { default as indexvyYPh2bWT6D2V9YhD8hq3gZFkUnRd6lSY_45WBglQNmIEMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/admin/users/index.vue?macro=true";
import { default as index27whT3JdSOdvaIB0LAptg8vuFZmBcd0MXuXFQcj7U54Meta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/discussions/index.vue?macro=true";
import { default as phengoldhEXTrzbJ9AWxS1ApIxJQ2LOt8ha7T_45zS1JXMqf8QJtcMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/phengold.vue?macro=true";
import { default as testogenPInFGeeGn06QFN35jJF9ONPcxA_b02A1_0Z9pX6QSbUMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/testogen.vue?macro=true";
import { default as trimtoneF7lbtjDR5gMt_45tCidplAeNpu8JWLPNb3l2WXKadJYVsMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/trimtone.vue?macro=true";
import { default as cancelu9ImwZY4i_BXh0uvqAH0A8RGsNT_mGfp5vjkGeJVV8UMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/terms/cancel.vue?macro=true";
import { default as refundtUaJ_yHGyLn_qOyuyuQbWjy6R_RHUBlMwQHs_459zi9ysMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/terms/refund.vue?macro=true";
import { default as createbWxJDZXmgeI0JbywtjsaG8aKXlWxrKAJJ0RMSJGW75IMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/admin/users/create.vue?macro=true";
import { default as blackwolfL0_yd4j3yLoluzesP_45iO__NdzNnUBlDhgPEKawrc6cwMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/blackwolf.vue?macro=true";
import { default as privacygejqkrucmsh9iv92GE9DSAzAssYEAkVZBeRio9B8GDcMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/terms/privacy.vue?macro=true";
import { default as indexfiZ1JsxlznElo_45LkDGM7NvbdjUgzAdHnUY77Q9EsgQsMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/admin/reviews/index.vue?macro=true";
import { default as berbaprimedI1j4o_cE6_45ymrcAPFhsYHeU5wNFsFz_vFo8JUVeBjYMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/berbaprime.vue?macro=true";
import { default as primeshredmd_X5bl7HDB5umZ6wMxcthsztOLddBFw6_45S6HBwvqSoMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/primeshred.vue?macro=true";
import { default as shippingAybLFs_45h_S3FulIU_45adyqqDXMuiBtp5ERReRqCyR2WgMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/terms/shipping.vue?macro=true";
import { default as createMS4QTOikub0RdI1nUOjcwF5olQoD8m8lO2EjQEVr3_45MMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/admin/reviews/create.vue?macro=true";
import { default as indexKMLPvBr8tn0QnkWgckTd23eezZfec72aw7P6FmZdstsMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/admin/redirects/index.vue?macro=true";
import { default as mindvitalityA_3VM27g37LCRKhIIe8i7LJSx0aAolNqtkPccqm5TYUMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/mindvitality.vue?macro=true";
import { default as notificationsjTs_YHFkRNAwZk_45JgYdfA7oyAvdZZvR3il6MMjsQaz8Meta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/profile/notifications.vue?macro=true";
import { default as createcYasklKaWi__Q8lFTDFA7EYjYRxi9GGeoLIq1Vj9WaAMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/admin/redirects/create.vue?macro=true";
import { default as subscriptions_45faqdXFek341hYVK8XY4hlXjWGYXWeRMXUgua4l7xs7rw2IMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/subscriptions-faq.vue?macro=true";
import { default as newiJDMZruw_45oYmlb2F_fIBiz9JJ21rpoCoX3s_Rn1YT48Meta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/discussions/[forum]/new.vue?macro=true";
import { default as _91id_934sAM6AKqDeECMIWgcbsi9UIAssTTj6xJdpT2u5ouMQQMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/goto/[...resource]/[id].vue?macro=true";
import { default as indexLjuktV7kFBwGfnpfipn_oCqW_45GaZzgygIK1TB79NejgMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/profile/[username]/index.vue?macro=true";
import { default as subscriptionseF4vYEyTTjns37aNK_45njEeaqN1hyK9WdgPVzuBCWswMMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/terms/subscriptions.vue?macro=true";
import { default as indexFz02VbwKNBnRGWIQVdQcJLtyKypGJFNdnmxTK_pUirkMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/discussions/[forum]/index.vue?macro=true";
import { default as _91_46_46_46product_93Ll1oGfG1ZfwJAiC7hpFDsHwaugyOfGldxTQTq8uga9kMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/buy/[...product].vue?macro=true";
import { default as indexZAtLHvJrURchOXHwQeA3sBrQXy4k6xD0V0XIygDm6x0Meta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/magazine/[...category]/index.vue?macro=true";
import { default as indexvyvMzvNZ4NEvhClWKVpW4VFAMu0zgpK5Etm3lnTefWwMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/[...category]/index.vue?macro=true";
import { default as indexmTeQkwcfbKipbiWLHZm4AOuD_OKsu85TB_45qz22AngA4Meta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/discussions/[forum]/[handle]/index.vue?macro=true";
import { default as _91article_93pTb4jgO_4580myt5DkXVFI_45dZzW1_456hSabNRDoJjNchpsMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/magazine/[...category]/article/[article].vue?macro=true";
import { default as indexUtBjI5vqTO18rwVMDrajty8OIxWkMU24zRfoHGcT_McMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/[...category]/product/[handle]/index.vue?macro=true";
import { default as reviewsbvaiVQ9101wikntdUEBVinj_45ZwTcBAP6dd9v_45BaQ_1oMeta } from "/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/[...category]/product/[handle]/reviews.vue?macro=true";
export default [
  {
    name: "blank",
    path: "/blank",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/blank.vue")
  },
  {
    name: "error",
    path: "/error",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/logout.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/index.vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/admin/index.vue")
  },
  {
    name: "leaderboard",
    path: "/leaderboard",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/leaderboard.vue")
  },
  {
    name: "about-brands",
    path: "/about/brands",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/brands.vue")
  },
  {
    name: "products-new",
    path: "/products/new",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/new.vue")
  },
  {
    name: "about-contact",
    path: "/about/contact",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/contact.vue")
  },
  {
    name: "about-experts",
    path: "/about/experts",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/experts.vue")
  },
  {
    name: "meetups",
    path: "/meetups",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/meetups/index.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/profile/index.vue")
  },
  {
    name: "about-creators",
    path: "/about/creators",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/creators.vue")
  },
  {
    name: "exercise",
    path: "/exercise",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/exercise/index.vue")
  },
  {
    name: "magazine",
    path: "/magazine",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/magazine/index.vue")
  },
  {
    name: "password",
    path: "/password",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/password/index.vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/index.vue")
  },
  {
    name: "register",
    path: "/register",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/register/index.vue")
  },
  {
    name: "about-terms-mbg",
    path: "/about/terms/mbg",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/terms/mbg.vue")
  },
  {
    name: "password-verify",
    path: "/password/verify",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/password/verify.vue")
  },
  {
    name: "products-zotrim",
    path: "/products/zotrim",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/zotrim.vue")
  },
  {
    name: "register-verify",
    path: "/register/verify",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/register/verify.vue")
  },
  {
    name: "about-affiliates",
    path: "/about/affiliates",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/affiliates.vue")
  },
  {
    name: "challenges",
    path: "/challenges",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/challenges/index.vue")
  },
  {
    name: "magazine-request",
    path: "/magazine/request",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/magazine/request.vue")
  },
  {
    name: "about-terms",
    path: "/about/terms",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/terms/index.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/admin/users/index.vue")
  },
  {
    name: "discussions",
    path: "/discussions",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/discussions/index.vue")
  },
  {
    name: "products-phengold",
    path: "/products/phengold",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/phengold.vue")
  },
  {
    name: "products-testogen",
    path: "/products/testogen",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/testogen.vue")
  },
  {
    name: "products-trimtone",
    path: "/products/trimtone",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/trimtone.vue")
  },
  {
    name: "about-terms-cancel",
    path: "/about/terms/cancel",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/terms/cancel.vue")
  },
  {
    name: "about-terms-refund",
    path: "/about/terms/refund",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/terms/refund.vue")
  },
  {
    name: "admin-users-create",
    path: "/admin/users/create",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/admin/users/create.vue")
  },
  {
    name: "products-blackwolf",
    path: "/products/blackwolf",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/blackwolf.vue")
  },
  {
    name: "about-terms-privacy",
    path: "/about/terms/privacy",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/terms/privacy.vue")
  },
  {
    name: "admin-reviews",
    path: "/admin/reviews",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/admin/reviews/index.vue")
  },
  {
    name: "products-berbaprime",
    path: "/products/berbaprime",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/berbaprime.vue")
  },
  {
    name: "products-primeshred",
    path: "/products/primeshred",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/primeshred.vue")
  },
  {
    name: "about-terms-shipping",
    path: "/about/terms/shipping",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/terms/shipping.vue")
  },
  {
    name: "admin-reviews-create",
    path: "/admin/reviews/create",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/admin/reviews/create.vue")
  },
  {
    name: "admin-redirects",
    path: "/admin/redirects",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/admin/redirects/index.vue")
  },
  {
    name: "products-mindvitality",
    path: "/products/mindvitality",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/mindvitality.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/profile/notifications.vue")
  },
  {
    name: "admin-redirects-create",
    path: "/admin/redirects/create",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/admin/redirects/create.vue")
  },
  {
    name: "about-subscriptions-faq",
    path: "/about/subscriptions-faq",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/subscriptions-faq.vue")
  },
  {
    name: "discussions-forum-new",
    path: "/discussions/:forum()/new",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/discussions/[forum]/new.vue")
  },
  {
    name: "goto-resource-id",
    path: "/goto/:resource([^/]*)*/:id()",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/goto/[...resource]/[id].vue")
  },
  {
    name: "profile-username",
    path: "/profile/:username()",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/profile/[username]/index.vue")
  },
  {
    name: "about-terms-subscriptions",
    path: "/about/terms/subscriptions",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/about/terms/subscriptions.vue")
  },
  {
    name: "discussions-forum",
    path: "/discussions/:forum()",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/discussions/[forum]/index.vue")
  },
  {
    name: "products-buy-product",
    path: "/products/buy/:product(.*)*",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/buy/[...product].vue")
  },
  {
    name: "magazine-category",
    path: "/magazine/:category(.*)*",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/magazine/[...category]/index.vue")
  },
  {
    name: "products-category",
    path: "/products/:category(.*)*",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/[...category]/index.vue")
  },
  {
    name: "discussions-forum-handle",
    path: "/discussions/:forum()/:handle()",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/discussions/[forum]/[handle]/index.vue")
  },
  {
    name: "magazine-category-article-article",
    path: "/magazine/:category([^/]*)*/article/:article()",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/magazine/[...category]/article/[article].vue")
  },
  {
    name: "products-category-product-handle",
    path: "/products/:category([^/]*)*/product/:handle()",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/[...category]/product/[handle]/index.vue")
  },
  {
    name: "products-category-product-handle-reviews",
    path: "/products/:category([^/]*)*/product/:handle()/reviews",
    component: () => import("/codebuild/output/src2218255124/src/client-healthnutrition/www/pages/products/[...category]/product/[handle]/reviews.vue")
  }
]